import { render, staticRenderFns } from "./WFConfigList.vue?vue&type=template&id=431a055e&scoped=true&"
import script from "./WFConfigList.vue?vue&type=script&lang=js&"
export * from "./WFConfigList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "431a055e",
  null
  
)

export default component.exports